import React from 'react';
import styled from 'styled-components';
import { FaWhatsapp, FaEnvelope, FaPhone } from 'react-icons/fa';
import type { IconType } from 'react-icons';
import {
  WHATSAPP_GROUP_URL,
  mailtoHref,
  PUBLIC_EMAIL,
  telHref,
  PUBLIC_PHONE_DISPLAY,
} from '../../constants/publicContact';

const AnnouncementBarContainer = styled.div`
  background: var(--primary-blue); /* Primary blue color */
  color: var(--white);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1100;
  height: var(--announcement-height);
  display: flex;
  align-items: center;
  font-size: 1rem;

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

const AnnouncementContent = styled.div`
  width: 100%;
  max-width: var(--container-width);
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 640px) {
    padding: 0 1.5rem;
  }

  @media (min-width: 1024px) {
    padding: 0 2rem;
  }

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const AnnouncementItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
  min-width: 0;

  @media (max-width: 768px) {
    gap: 0.5rem;
    white-space: normal;
    justify-content: center;
    text-align: center;
  }

  a {
    color: var(--white);
    text-decoration: none;
    transition: all 0.3s ease;
    padding: 0.25rem 0;

    &:hover {
      color: var(--text-black);
      opacity: 0.9;
    }
  }
`;

const AnnouncementContact = styled.div`
  display: flex;
  gap: 1.5rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
`;

const StyledIcon = styled.div.attrs<{ as: IconType }>(() => ({
  // This empty attrs is needed to properly type the 'as' prop
}))<{ as: IconType }>`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 1em;
    height: 1em;
  }
`;

const AnnouncementBar: React.FC = () => {
  return (
    <AnnouncementBarContainer>
      <AnnouncementContent>
        <AnnouncementItem>
          <IconWrapper>
            <StyledIcon as={FaWhatsapp} />
          </IconWrapper>
          <a href={WHATSAPP_GROUP_URL} target="_blank" rel="noopener noreferrer">
            Junte-se ao nosso grupo de WhatsApp!
          </a>
        </AnnouncementItem>
        <AnnouncementContact>
          <AnnouncementItem>
            <IconWrapper>
              <StyledIcon as={FaEnvelope} />
            </IconWrapper>
            <a href={mailtoHref}>{PUBLIC_EMAIL}</a>
          </AnnouncementItem>
          <AnnouncementItem>
            <IconWrapper>
              <StyledIcon as={FaPhone} />
            </IconWrapper>
            <a href={telHref}>{PUBLIC_PHONE_DISPLAY}</a>
          </AnnouncementItem>
        </AnnouncementContact>
      </AnnouncementContent>
    </AnnouncementBarContainer>
  );
};

export default AnnouncementBar;
